import { ics_1_slidedeck } from './SL20000Sprint01'
import { ics_2_slidedeck } from './SL20000Sprint02'
import { ics_3_slidedeck } from './SL20000Sprint03'
import { ics_4_slidedeck } from './SL20000Sprint04'
import { tUnderConstruction } from './SL00000Sprint00'

import { ics_1_slidedeckTTR } from './SL20000Sprint01TTR'
import { ics_2_slidedeckTTR } from './SL20000Sprint02TTR'
import { ics_3_slidedeckTTR } from './SL20000Sprint03TTR'
import { ics_4_slidedeckTTR } from './SL20000Sprint04TTR'
import { ics_5_slidedeckTTR } from './SL20000Sprint05TTR'
import { ics_6_slidedeckTTR } from './SL20000Sprint06TTR'
import { ics_7_slidedeckTTR } from './SL20000Sprint07TTR'
import { ics_8_slidedeckTTR } from './SL20000Sprint08TTR'

const uCSD = [ tUnderConstruction ] // A uCSD is an array of one tUnderConstruction slide.
const uCM = [ uCSD, uCSD, uCSD, uCSD, uCSD, uCSD ] // A uCM is an array of 6 class sessions each containing a UCSDs.
export const ics_slidedeck = [ ics_1_slidedeck, ics_2_slidedeck, ics_3_slidedeck, ics_4_slidedeck, uCM, uCM, uCM, uCM ]

// const uCM4 = [ uCSD, uCSD, uCSD, uCSD ] // A uCM4 is an array of 4 class sessions each containing a UCSDs.
export const _CPSC_20000_SLIDEDECK_TTR = [ ics_1_slidedeckTTR, ics_2_slidedeckTTR, ics_3_slidedeckTTR, ics_4_slidedeckTTR, 
	ics_5_slidedeckTTR, ics_6_slidedeckTTR, ics_7_slidedeckTTR, ics_8_slidedeckTTR]